export const INIT_STATE = {
    dbParam: null,
    canteens: null,
    canteenList: null,
    canteenData: null,
    predictionData: null,
    predictionLoading: false,
    predictionError: false,
    canteenId: null,
    organizationId: null,
    canteenIds: null,
    success: false,
    message: null,
    loading: false,
    loading1: false,
    loading2: false,
    editCanteenLoading: false,
    error: null,
    crockeryLoading: false,
    weightedListLoading: false,
    weightedListLoading1: false,
    weightedList: null,
    defaultCanteenSettings: null,
    listCanteenSettings: null,
    subsidyAgreements: null,
    subsidyAgreementsLoading: false,
    subsidyAgreementsError: false,
    subsidyAgreementDetails: null,
    subsidyAgreementDetailsLoading: false,
    subsidyAgreementDetailsError: false,

    priceRules: null,
    priceRulesLoading: false,
    priceRulesError: false,
    priceRuleDetails: null,
    priceRuleDetailsLoading: false,
    priceRuleDetailsError: false,

    guestDiscountsByCategory: null,
    guestDiscountsByCategoryLoading: false,
    guestDiscountsByCategoryError: false,

    categoriesByGuestDiscount: null,
    categoriesByGuestDiscountLoading: false,
    categoriesByGuestDiscountError: false,

    // Custom Tab
    customTabData: null,
    customTabLoading: false,
    customTabError: false,
    customTabUpdateLoading: false,
    customTabUpdateError: false,

    customSortedTabData: null,
    customSortedTabLoading: false,
    customSortedTabError: false,
    customSortedTabUpdateLoading: false,
    customSortedTabUpdateError: false,
}; 